/* ADORINSE — shared interactions (Shopify)
   nav state · scroll reveal · parallax · count-up · AJAX cart · predictive search */
(function () {
  'use strict';

  var money = window.AD && window.AD.moneyFormat ? window.AD.moneyFormat : '${{amount}}';
  function formatMoney(cents) {
    var value = cents / 100;
    return money.replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2))
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString())
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.toFixed(2).replace('.', ','));
  }
  if (window.AD) { window.AD.format = formatMoney; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- header scrolled state ---------- */
  var header = document.querySelector('.site-header');
  function navScroll() {
    if (!header) return;
    if (window.scrollY > 24) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }
  navScroll();
  window.addEventListener('scroll', navScroll, { passive: true });

  /* ---------- scroll reveal (probe transition support, then rect-based) ---------- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  function runReveal() {
    var pending = reveals.slice();
    var revealCheck = function () {
      if (!pending.length) return;
      var vh = window.innerHeight;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('in'); return false; }
        return true;
      });
    };
    revealCheck();
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('resize', revealCheck, { passive: true });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('in'); }); }, 3000);
  }
  if (!reduce && reveals.length) {
    root.classList.add('reveal-init');
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-9999px;top:0;width:4px;height:4px;opacity:0;transition:opacity .3s linear;';
    document.body.appendChild(probe);
    void probe.offsetWidth;
    probe.style.opacity = '1';
    setTimeout(function () {
      var op = parseFloat(getComputedStyle(probe).opacity);
      probe.remove();
      if (op > 0.02) { runReveal(); }
      else { root.classList.remove('reveal-init'); }  // frozen context — show everything
    }, 130);
  }

  /* ---------- parallax (hero product, float chips, scene bg) ---------- */
  var heroProduct = document.querySelector('[data-parallax-product]');
  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-chip]'));
  var sceneBg = document.querySelector('[data-parallax-scene]');
  var sceneEl = sceneBg ? sceneBg.closest('.scene') : null;
  var ticking = false;
  function parallax() {
    var y = window.scrollY;
    if (heroProduct) heroProduct.style.transform = 'translateY(' + (y * 0.06) + 'px)';
    chips.forEach(function (c, i) {
      var speed = [0.12, -0.1, 0.16][i % 3];
      c.style.transform = 'translateY(' + (y * speed) + 'px)';
    });
    if (sceneBg && sceneEl) {
      var rect = sceneEl.getBoundingClientRect();
      var vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        var progress = (vh - rect.top) / (vh + rect.height);
        var shift = (progress - 0.5) * 80;
        sceneBg.style.transform = 'translateY(' + shift + 'px) scale(1.12)';
      }
    }
    ticking = false;
  }
  if (!reduce && (heroProduct || chips.length || sceneBg)) {
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    parallax();
  }

  /* ---------- animated stat count-up (rect-based) ---------- */
  var counters = Array.prototype.slice.call(document.querySelectorAll('[data-count]'));
  function fmtN(v, dec) { return dec ? v.toFixed(dec) : Math.round(v).toString(); }
  function runCount(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var target = parseFloat(el.dataset.count);
    var dec = (el.dataset.count.split('.')[1] || '').length;
    if (reduce) { el.textContent = fmtN(target, dec); return; }
    var dur = 1400, start = performance.now();
    (function step(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmtN(target * eased, dec);
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }
  if (counters.length) {
    var countCheck = function () {
      var vh = window.innerHeight;
      counters.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.85 && r.bottom > 0) runCount(el);
      });
    };
    countCheck();
    window.addEventListener('scroll', countCheck, { passive: true });
    setTimeout(function () { counters.forEach(runCount); }, 2800);
  }

  /* ---------- mobile drawer ---------- */
  var burgers = document.querySelectorAll('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    if (drawer.id) { burgers.forEach(function (b) { b.setAttribute('aria-controls', drawer.id); }); }
    function setDrawerState(open) {
      drawer.classList.toggle('open', open);
      document.body.classList.toggle('no-scroll', open);
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    burgers.forEach(function (b) {
      b.setAttribute('aria-expanded', drawer.classList.contains('open') ? 'true' : 'false');
      b.addEventListener('click', function () { setDrawerState(!drawer.classList.contains('open')); });
    });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setDrawerState(false); }); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) { setDrawerState(false); } });
  }

  /* ---------- cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  function openCart() { if (cartDrawer) { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); document.body.classList.add('no-scroll'); } }
  function closeCart() { if (cartDrawer) { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { if (cartDrawer) { e.preventDefault(); openCart(); } });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
  if (cartOverlay) { cartOverlay.addEventListener('click', closeCart); }
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') { closeCart(); closeSearch(); } });

  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('show', n > 0);
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body) return;
    paintCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty flow"><p class="eyebrow">Empty</p><p class="lede">Your cart is quiet for now.</p><a href="/collections/all" class="btn btn-primary" data-cart-close>Shop the range</a></div>';
      if (foot) foot.style.display = 'none';
      body.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
      document.dispatchEvent(new CustomEvent('cart:render', { detail: cart }));
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]+)($|\?)/, '_160x$1$2') + '" alt="' + it.product_title + '">' : '';
      var variant = (it.product_has_only_default_variant ? '' : it.variant_title) || '';
      return '<div class="mini-line">' +
        '<a href="' + it.url + '" class="ph ph--celadon mini-line__media">' + img + '</a>' +
        '<div><div class="mini-line__name">' + it.product_title + '</div>' +
        (variant ? '<div class="mini-line__var">' + variant + '</div>' : '') +
        '<div class="qty" style="margin-top:10px"><button data-line-dec="' + it.key + '" aria-label="Decrease">–</button><span>' + it.quantity + '</span><button data-line-inc="' + it.key + '" aria-label="Increase">+</button></div>' +
        '<button class="mini-line__rm" data-line-remove="' + it.key + '">Remove</button></div>' +
        '<div class="mini-line__price">' + formatMoney(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    if (foot) {
      var subEl = foot.querySelector('[data-cart-subtotal]');
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
      var bar = foot.querySelector('[data-cart-progress]');
      var msg = foot.querySelector('[data-cart-ship-msg]');
      var threshold = window.AD && window.AD.freeShip ? window.AD.freeShip : 0;
      if (bar && threshold) {
        var pct = Math.min(1, cart.total_price / threshold);
        bar.style.transform = 'scaleX(' + pct + ')';
        var left = threshold - cart.total_price;
        msg.innerHTML = cart.total_price >= threshold ? "You've earned <b>free shipping</b>." : '<b>' + formatMoney(left) + '</b> away from free shipping.';
      }
    }
    bindDrawerLines();
    document.dispatchEvent(new CustomEvent('cart:render', { detail: cart }));
  }
  function bindDrawerLines() {
    function pending(el) { var line = el.closest('.mini-line'); if (line) line.classList.add('is-updating'); }
    document.querySelectorAll('[data-line-remove]').forEach(function (b) { b.onclick = function () { pending(b); changeLine(b.getAttribute('data-line-remove'), 0); }; });
    document.querySelectorAll('[data-line-inc]').forEach(function (b) { b.onclick = function () { pending(b); adjustLine(b.getAttribute('data-line-inc'), 1); }; });
    document.querySelectorAll('[data-line-dec]').forEach(function (b) { b.onclick = function () { pending(b); adjustLine(b.getAttribute('data-line-dec'), -1); }; });
  }
  function adjustLine(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.filter(function (i) { return i.key === key; })[0];
      if (it) changeLine(key, Math.max(0, it.quantity + delta));
    });
  }
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }
  window.adRefreshCart = function () { fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer); };
  window.adOpenCart = openCart;
  window.adCloseCart = closeCart;

  /* ---------- add to cart (AJAX, delegated — also binds late-injected forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"], form[data-add-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.innerHTML = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = orig; }
          showToast(res.d.description || 'Could not add to cart');
          return;
        }
        // success feedback: brief "Added ✓" pulse before the label restores
        if (btn) {
          btn.removeAttribute('disabled');
          btn.classList.add('is-added');
          btn.innerHTML = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = orig; }, 1200);
        }
        window.adRefreshCart();
        openCart();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res.d }));
      })
      .catch(function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = orig; } });
  });

  /* ---------- toast ---------- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (msg) { toast.childNodes[0].nodeValue = msg + ' '; }
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }
  window.adToast = showToast;

  /* ---------- predictive search v2 (products + suggestions + pages/articles,
                 recent searches + popular searches idle state) ---------- */
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = searchPanel ? searchPanel.querySelector('input[type=search]') : null;
  var searchResults = searchPanel ? searchPanel.querySelector('[data-search-results]') : null;
  var SEARCH_KEY = 'ad:searches';
  function escS(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function recentSearches() {
    try { return JSON.parse(localStorage.getItem(SEARCH_KEY) || '[]'); } catch (e) { return []; }
  }
  function rememberSearch(q) {
    if (!q || q.length < 2) return;
    try {
      var list = recentSearches().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(SEARCH_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) {}
  }
  function chipRow(items, kind) {
    return '<div class="sp-chips">' + items.map(function (t) {
      return '<button type="button" data-search-fill="' + escS(t) + '">' +
        (kind === 'recent'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>') +
        escS(t) + '</button>';
    }).join('') + '</div>';
  }
  function renderSearchIdle() {
    if (!searchResults) return;
    var html = '';
    var recent = recentSearches();
    if (recent.length) {
      html += '<div class="sp-h">Recent searches <button type="button" class="sp-clear" data-search-clear-recent>Clear</button></div>' + chipRow(recent, 'recent');
    }
    var popular = (window.AD && window.AD.popularSearches ? window.AD.popularSearches : '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (popular.length) {
      html += '<div class="sp-h">Popular</div>' + chipRow(popular, 'popular');
    }
    searchResults.innerHTML = html ? '<div class="sp-idle">' + html + '</div>' : '';
  }
  function highlight(text, q) {
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i === -1) return escS(text);
    return escS(text.slice(0, i)) + '<b>' + escS(text.slice(i, i + q.length)) + '</b>' + escS(text.slice(i + q.length));
  }
  function renderSearchResults(data, q) {
    var res = (data.resources && data.resources.results) || {};
    var products = res.products || [];
    var queries = res.queries || [];
    var pages = (res.pages || []).concat(res.articles || []);
    if (!products.length && !queries.length && !pages.length) {
      searchResults.innerHTML = '<p class="sp-empty">No matches for &ldquo;' + escS(q) + '&rdquo; yet. Try &ldquo;bidet&rdquo; or &ldquo;seat&rdquo;.</p>';
      return;
    }
    var side = '';
    if (queries.length) {
      side += '<div class="sp-h">Suggestions</div><div class="sp-sug">' + queries.slice(0, 5).map(function (s) {
        return '<a href="' + escS(s.url) + '" data-search-track="' + escS(s.text) + '">' + highlight(s.text, q) + '</a>';
      }).join('') + '</div>';
    }
    if (pages.length) {
      side += '<div class="sp-h">Pages &amp; guides</div><div class="sp-pages">' + pages.slice(0, 4).map(function (pg) {
        return '<a href="' + escS(pg.url) + '">' + escS(pg.title) + '</a>';
      }).join('') + '</div>';
    }
    var main = '';
    if (products.length) {
      main = '<div class="prod-grid cols-4">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + escS(p.featured_image.url) + '" alt="' + escS(p.title) + '">' : '';
        return '<a href="' + escS(p.url) + '" class="card"><div class="ph ph--celadon card__media">' + img + '</div><div class="card__name" style="font-size:1.15rem">' + escS(p.title) + '</div><div class="card__price" style="margin-top:6px">' + escS(p.price) + '</div></a>';
      }).join('') + '</div>';
    } else {
      main = '<p class="sp-empty">No products match &ldquo;' + escS(q) + '&rdquo;.</p>';
    }
    main += '<a class="sp-all" href="/search?q=' + encodeURIComponent(q) + '" data-search-track="' + escS(q) + '">See all results →</a>';
    searchResults.innerHTML = side
      ? '<div class="sp-grid"><div class="sp-side">' + side + '</div><div class="sp-main">' + main + '</div></div>'
      : main;
  }
  function openSearch() {
    if (searchPanel) {
      searchPanel.classList.add('open'); document.body.classList.add('no-scroll');
      if (searchInput) searchInput.focus();
      if (searchResults && !searchResults.innerHTML.trim()) renderSearchIdle();
    }
  }
  function closeSearch() { if (searchPanel) { searchPanel.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-search-open]').forEach(function (el) { el.addEventListener('click', function (e) { if (searchPanel) { e.preventDefault(); openSearch(); } }); });
  document.querySelectorAll('[data-search-close]').forEach(function (el) { el.addEventListener('click', closeSearch); });
  var searchTimer;
  function runSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!searchInput || searchInput.value.trim() !== q) return; // stale response
        renderSearchResults(data, q);
      });
  }
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { renderSearchIdle(); return; }
      searchTimer = setTimeout(function () { runSearch(q); }, 220);
    });
    var searchForm = searchInput.closest('form');
    if (searchForm) { searchForm.addEventListener('submit', function () { rememberSearch(searchInput.value.trim()); }); }
  }
  if (searchPanel) {
    searchPanel.addEventListener('click', function (e) {
      var fill = e.target.closest ? e.target.closest('[data-search-fill]') : null;
      if (fill) {
        var q = fill.getAttribute('data-search-fill');
        searchInput.value = q; searchInput.focus(); rememberSearch(q); runSearch(q);
        return;
      }
      if (e.target.closest && e.target.closest('[data-search-clear-recent]')) {
        try { localStorage.removeItem(SEARCH_KEY); } catch (err) {}
        renderSearchIdle();
        return;
      }
      var track = e.target.closest ? e.target.closest('[data-search-track]') : null;
      if (track) rememberSearch(track.getAttribute('data-search-track'));
    });
  }
  window.adCloseSearch = closeSearch;

  // initial paint
  window.adRefreshCart();
})();
